import React from 'react';
import { Skeleton } from '../components';
import { getSkills, getWorkExperiences } from '../utils/groq';
import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { urlFor } from '../client';

const Expertise = () => {
    const [skills, setSkills] = React.useState([])
    const [experiences, setExperiences] = React.useState([])
    const [skillsLoaded, setSkillsLoaded] = React.useState(false)
    const [experienceLoaded, setExperienceLoaded] = React.useState(false)

    React.useEffect(() => {
        getSkills()
            .then(data => {
                setSkills(data)
                setSkillsLoaded(true)
            })
            .catch(error => console.log('skills issue: ', error))
        getWorkExperiences()
            .then(workExperiences => {
                setExperiences(workExperiences)
                setExperienceLoaded(true)
            })
            .catch(error => console.log('experiences fetching issue: ', error))
    }, [])

    return (
        <section className="expertise w-100 pb-5" id="expertise">
            <Container>
                <h2 className='my-5'>
                    Mon
                    <span className='text-purple'> Expertise </span>
                    &
                    <span className='text-purple'> Expérience</span></h2>
                <Row className="flex-md-row flex-column gap-md-0 gap-5 mt-3">
                    <Col>
                        <div
                            className="d-flex flex-wrap justify-content-lg-start align-items-lg-start me-xl-5 me-lg-3 justify-content-center align-items-center me-0"
                            data-zanim-xs='{"delay": 0.3, "animation": "slide-left"}'
                            data-zanim-trigger='scroll'
                        >
                            {skillsLoaded && skills.map((skill, index) => {
                                return (
                                    <div
                                        key={`${skill.name}-${index}`}
                                        className="d-flex flex-column text-center me-3"
                                        data-zanim-xs={`{"delay": 0.${index + 40},"animation":"blur-in"}`}
                                        data-zanim-trigger="scroll"
                                    >
                                        <div
                                            className="rounded-circle d-flex justify-content-center align-items-center expertise__skill-item"
                                            style={{ backgroundColor: `${skill.bgColor ?? "#fff"}` }}
                                        >
                                            <img
                                                src={urlFor(skill.icon)}
                                                alt={skill.name}
                                                className="w-50 h-50"
                                            />
                                        </div>
                                        <p className='fw-normal mt-2 mt-xl-3'>{skill.name}</p>
                                    </div>
                                )
                            })}
                            {!skillsLoaded && Array(6).fill(0).map((_, index) => (
                                <div key={index} className="d-flex flex-column justify-content-center text-center me-3">
                                    <Skeleton circle width={65} height={65} />
                                    <span className="self-align-center mt-1 mb-2">
                                        <Skeleton width={35} />
                                    </span>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col>
                        <div
                            data-zanim-xs='{"delay": 0.3, "animation": "slide-left"}'
                            data-zanim-trigger='scroll'
                        >
                            {experienceLoaded && experiences.map((experience, expIndex) => (
                                <div
                                    key={`${experience.year}-work-experience`}
                                    className="d-flex align-items-start gap-md-4 gap-5 mb-3"
                                    data-zanim-xs={`{"delay": 0.${expIndex + 40},"animation":"blur-in"}`}
                                    data-zanim-trigger="scroll"
                                >
                                    <p className="text-purple fw-bolder fs-4">
                                        {experience.year}
                                    </p>
                                    {experience.works.map((ew, index) => (
                                        <OverlayTrigger
                                            key={`${ew.name}-${index}`}
                                            // delay={{ hide: 450, show: 300 }}
                                            placement='top'
                                            overlay={(props) => (
                                                <Tooltip {...props}>
                                                    {ew.desc}
                                                </Tooltip>
                                            )}
                                        >
                                            <div className="cursor-pointer">
                                                <h4 className="fw-normal font-monospace">{ew.name}</h4>
                                                <p className="text-secondary mt-3">{ew.company}</p>
                                            </div>
                                        </OverlayTrigger>
                                    ))}
                                </div>
                            ))}
                            {!experienceLoaded && Array(3).fill(0).map((_, i) => (
                                <div key={i} className="d-flex align-items-start gap-md-4 gap-5 mb-3">
                                    <Skeleton width={50} />
                                    <div className="d-block col">
                                        <Skeleton />
                                        <Skeleton width={150} />
                                    </div>
                                </div>
                            ))
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Expertise